import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: API
});

// ✅ REQUEST INTERCEPTOR (attach token automatically)
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// ✅ RESPONSE INTERCEPTOR (auto logout on expiry)
api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response?.status === 401 || err.response?.status === 403) {
            localStorage.clear();
            window.location.href = "/login";
        }
        return Promise.reject(err);
    }
);

export default api;